module.exports = __webpack_public_path__ + "static/ecommerce-ux-081fa06312a7ee84026aa19172d1ebea.png";